import React from 'react';
import Joi from 'joi';
import PropTypes from 'prop-types';

import Button from '../../themed/button';
import Form from '../../common/form';

class VIRecommendationItemForm extends Form {
	state = {
		data: { recommendation: '' },
		errors: {},
		loading: false,
		progress: 0,
	};

	static propTypes = {
		onAddRecommendation: PropTypes.func.isRequired,
	};

	schema = {
		recommendation: Joi.string()
			.min(10)
			.required()
			.label('Recommendation / Action'),
	};

	handleKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
		if (event.code !== 'Enter') return;

		event.preventDefault();
		this.doSubmit();
	};

	doSubmit = () => {
		const errors: any = this.validate();
		if (errors) {
			this.setState({ errors: errors || {} }, this.handleFormErrorNotice);
		} else {
			this.props.onAddRecommendation(this.state.data.recommendation);

			const data = { ...this.state.data, recommendation: '' };
			this.setState({ data });
		}
	};

	render() {
		return (
			<div className="row">
				<div className="col-9">
					{this.renderInput({
						type: 'text',
						name: 'recommendation',
						placeholder: 'Enter Recommendation / Action',
						label: 'Recommendation / Action',
						onKeyDown: this.handleKeyPress,
					})}
				</div>

				<div className="col">
					<Button label="" icon="plus" type="button" onClick={this.doSubmit} />
				</div>
			</div>
		);
	}
}

export default VIRecommendationItemForm;
